import type { ICalendarResources } from "@/design-system/day-picker/calendar.Resources";

export const CalendarResourcesEn: ICalendarResources = {
    months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
    ],
    weekdays: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
};
